import posthog from 'posthog-js';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function usePostHogPageview(): void {
  const location = useLocation();

  useEffect(() => {
    posthog.capture('$pageview', {
      $current_url: window.location.href,
      path: location.pathname,
      search: location.search,
    });
  }, [location]);
}

export default usePostHogPageview;
